// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"05fec34c","233":"18422236","284":"4b15d3a0","469":"7a590d9a","493":"a00c20ea","626":"cc2a0013","726":"7d7a7c47","742":"bab16b23","911":"321d1759"}[chunkId] + ".chunk.js";
};